export default __webpack_public_path__ + "9f014efca1bbac9e8a4db14ad422340d.png";